/**
 * Evaluates whether a Glob wildcard pattern (e.g. /listings/*) matches the current page location.
 *
 * @param {string} pattern - The Glob pattern.
 * @param {string} path - Relative URL path (window.location.pathname).
 * @param {string} href - Full absolute URL (window.location.href).
 * @returns {boolean} True if the pattern matches either the relative path or full URL.
 */
export function matchUrlPattern(pattern, path, href) {
  if (!pattern) {
    return false;
  }
  const escaped = pattern.replace(/[.+^${}()|[\]\\]/g, '\\$&');
  const regexStr = '^' + escaped.replace(/\*/g, '.*') + '$';
  const regex = new RegExp(regexStr, 'i');
  return regex.test(path) || regex.test(href);
}

/**
 * Resolves the appropriate action buttons to display when the chat window is empty.
 * First contextual rule matching the current URL wins. Defaults to general suggestedButtons.
 *
 * @param {Object} config - The global configuration options.
 * @param {Object} fallbackButtons - Default suggestion buttons if no configs or rules match.
 * @returns {Array} List of button objects to render.
 */
export function resolveSuggestedButtons(config, fallbackButtons) {
  const path = typeof window !== 'undefined' ? window.location.pathname : '';
  const href = typeof window !== 'undefined' ? window.location.href : '';

  if (Array.isArray(config?.contextualButtons)) {
    for (let i = 0; i < config.contextualButtons.length; i++) {
      const rule = config.contextualButtons[i];
      if (matchUrlPattern(rule?.pattern, path, href) && Array.isArray(rule?.buttons) && rule.buttons.length > 0) {
        return rule.buttons;
      }
    }
  }

  if (Array.isArray(config?.suggestedButtons) && config.suggestedButtons.length > 0) {
    return config.suggestedButtons;
  }

  return fallbackButtons;
}
